import { carouselData } from '@/mocks/homeData';

const imageUrls = [
  'https://readdy.ai/api/search-image?query=Epic%20summer%20blockbuster%20movie%20collage%20with%20dramatic%20explosions%20golden%20sunset%20sky%20cinematic%20wide%20screen%20composition%20powerful%20action%20scenes%20rich%20warm%20color%20palette%20film%20poster%20style&width=1000&height=500&seq=carousel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Korean%20Japanese%20drama%20poster%20style%20with%20cherry%20blossoms%20and%20neon%20city%20lights%20romantic%20atmosphere%20soft%20cinematic%20lighting%20elegant%20composition%20emotional%20storytelling%20beautiful%20aesthetic&width=1000&height=500&seq=carousel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20animation%20epic%20scene%20with%20ancient%20warriors%20mystical%20beasts%20floating%20islands%20dramatic%20clouds%20beautiful%20traditional%20art%20style%20cinematic%20lighting%20sweeping%20landscape%20rich%20colors&width=1000&height=500&seq=carousel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mysterious%20detective%20scene%20with%20magnifying%20glass%20old%20books%20dim%20desk%20lamp%20shadows%20on%20wall%20film%20noir%20atmosphere%20rich%20textures%20cinematic%20moody%20lighting%20dark%20moody%20tones&width=1000&height=500&seq=carousel-04&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          焦点专题
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={imageUrls[i]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-[11px] font-semibold mb-2 whitespace-nowrap">
                  {item.subtitle}
                </span>
                <h3 className="text-lg md:text-xl font-heading text-background-50 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-background-50/80 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}